import Conversion from './conversion'
import Bugsnag from '@bugsnag/js'

export default class extends Conversion {
  async install () {
    Bugsnag.start({ apiKey: '5b408cd7bcf88f3ff69b4eaccd455382' })
    globalThis.Bugsnag = Bugsnag
  }

  push () {}
  defer () {}
  processDeferred () {}
}
